import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';
import { Box, Grid, Typography } from '@mui/material';
import FormattedAddress from 'components/shared/address/formatted-address.component';

type LabSectionProps = {
    order: Order;
};
const LabSection: FC<LabSectionProps> = ({ order }: LabSectionProps) => {
    const { t: translate } = useTranslation(['orders', 'organization', 'transport']);

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">{translate('common:NAME')}</Typography>
                    <Box>{order.supplier.name}</Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">{translate('organization:ADDRESS.ADDRESS')}</Typography>
                    <FormattedAddress address={order.supplier.contact.address} />
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">{translate('organization:CONTACT_INFO')}</Typography>
                    <Box>{order.supplier.contact?.communication?.phone}</Box>
                    <Box>{order.supplier.contact?.communication?.email}</Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LabSection;
